import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-review-row',
    templateUrl: './review-row.component.html',
    styleUrls: ['./review-row.component.css'],
    standalone: false
})
export class ReviewRowComponent {

  @Input() starLabel = '';
  @Input() count = 0;
  @Input() total = 1; 

   get percentage(): number {
    return (this.count / this.total) * 100;
  }
}
